import { BasePayloadMapper } from '@ps/utils';
import {
  SupplierManagedAllocationRow,
  SupplierManagedAllocationsUpdate,
} from '@ps/survey-utils';

import {
  SupplierAllocationsUpdateMemberDto,
  SupplierAllocationsUpdateRowDto,
} from '../dtos/supplier.dto';

export class SupplierManagedAllocationsBodyPayloadMapper extends BasePayloadMapper<
  SupplierManagedAllocationsUpdate,
  SupplierAllocationsUpdateRowDto[]
> {
  /**
   * One body row per panel row — the row's own quantity is sent as-is (no goal
   * redistribution), and the economics join already happened in the feature.
   */
  public toPayload(
    update: SupplierManagedAllocationsUpdate,
  ): SupplierAllocationsUpdateRowDto[] {
    return update.rows.map((row) => this._toRow(row, update));
  }

  private _toRow(
    row: SupplierManagedAllocationRow,
    update: SupplierManagedAllocationsUpdate,
  ): SupplierAllocationsUpdateRowDto {
    return {
      bid_cpi: row.bidCpi,
      completes_goal: row.completesGoal,
      cpi: update.context.globalOverrideValue.unwrapOr(row.cpi),
      current_target: row.quantity,
      flexValue: row.flexibility,
      group_name: row.isGroup ? row.name : '',
      quantity: row.quantity,
      suppliers: this._membersFor(row),
    };
  }

  private _membersFor(
    row: SupplierManagedAllocationRow,
  ): SupplierAllocationsUpdateMemberDto[] {
    return row.members.map((member) => ({
      id: Number(member.id),
      name: member.name,
      allocation: member.allocation,
    }));
  }
}
